import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';

import { FROZEN_TIME, useDynamicYieldValues } from '../../../../utils/dynamicYield';

import MobileYieldBox from './MobileYieldBox';

function MobileYieldTable() {
  const { values: dynamicYieldValues, textTemplates } = useDynamicYieldValues();
  const showAdditionalDisclaimer = (textTemplates.ADDITIONAL_DISCLAIMER_BULLETS ?? []).length > 0;

  return (
    <Box display={{ xs: 'block', lg: 'none' }}>
      <MobileYieldBox
        days={FROZEN_TIME.NO_FROZEN_TURBO}
        percentage={dynamicYieldValues.dynamicYieldTurbo}
        gatNominal={dynamicYieldValues.dynamicGATNominalTurbo}
        gatReal={dynamicYieldValues.dynamicGATRealTurbo}
        className="opacity-full-purple"
        highlighted
      />

      <MobileYieldBox
        days={FROZEN_TIME.NO_FROZEN}
        percentage={dynamicYieldValues.dynamicYield}
        gatNominal={dynamicYieldValues.dynamicGATNominal}
        gatReal={dynamicYieldValues.dynamicGATReal}
        className="opacity-80"
        appendRateDisclaimerAsterisk={showAdditionalDisclaimer}
      />

      <MobileYieldBox
        days={FROZEN_TIME.A_7_DAYS}
        percentage={dynamicYieldValues.dynamicYield7Days}
        gatNominal={dynamicYieldValues.dynamicGATNominal7Days}
        gatReal={dynamicYieldValues.dynamicGATReal7Days}
        className="opacity-60"
      />

      <MobileYieldBox
        days={FROZEN_TIME.A_28_DAYS}
        percentage={dynamicYieldValues.dynamicYield28Days}
        gatNominal={dynamicYieldValues.dynamicGATNominal28Days}
        gatReal={dynamicYieldValues.dynamicGATReal28Days}
        className="opacity-40"
      />

      <MobileYieldBox
        days={FROZEN_TIME.A_90_DAYS}
        percentage={dynamicYieldValues.dynamicYield90Days}
        gatNominal={dynamicYieldValues.dynamicGATNominal90Days}
        gatReal={dynamicYieldValues.dynamicGATReal90Days}
        className="opacity-30"
      />

      <MobileYieldBox
        days={FROZEN_TIME.A_180_DAYS}
        percentage={dynamicYieldValues.dynamicYield180Days}
        gatNominal={dynamicYieldValues.dynamicGATNominal180Days}
        gatReal={dynamicYieldValues.dynamicGATReal180Days}
        className="opacity-30"
      />

    </Box>
  );
}

export default MobileYieldTable;
